import pdfMake, {
  userMark,
  setMyConfig,
  makeTableContent
} from "../../../utils/pdf";

function liquidacionDetallePdf(payload) {
  const columns = [
    "fecha:wauto",
    "servicio:w*",
    "hotel:w*",
    {
      key: "tipo",
      label: "Tipo",
      width: "auto"
    },
    {
      key: "moneda",
      label: "Moneda",
      width: "auto"
    },
    {
      key: "monto",
      label: "Monto",
      width: 50
    },
    "observaciones:w*"
  ];

  const table = makeTableContent([...payload.items], columns);

  pdfMake
    .createPdf({
      info: {
        title: `Detalle de Liquidación`
      },
      content: [
        {
          text: "Detalle de Liquidación",
          style: "h1"
        },
        {
          columns: [
            {
              text: `Agencia: ${payload.header.agencia}`,
              width: "auto"
            },
            {
              text: `Código: ${payload.header.codigo}`,
              width: "auto"
            }
          ],
          margin: [0, 0, 0, 5]
        },
        {
          columns: [
            {
              text: `Pasajero: ${payload.header.pasajero}`,
              width: "auto"
            },
            {
              text: `Idioma: ${payload.header.idioma}`,
              width: "auto"
            },
            {
              text: `PAX: ${payload.header.pax}`,
              width: "auto"
            },
            {
              text: `CHD: ${payload.header.chd || ""}`,
              width: "auto"
            },

            {
              text: `Fecha Liquidación: ${payload.header.fecha}`,
              width: "auto"
            }
          ],
          margin: [0, 0, 0, 5]
        },
        table,
        ...userMark(payload.userMark, payload.dateMark)
      ],
      ...setMyConfig("vertical")
    })
    .print();
}

export default liquidacionDetallePdf;
